exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#patternConfiguration {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  flex-direction: column;\r\n  transition: flex 0.4s;\r\n}\r\n#patternConfigurationBody {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex-grow: 5;\r\n}\r\nbutton#addNewPattern {\r\n  position: absolute;\r\n  right: 25px;\r\n  bottom: 25px;\r\n  background: teal;\r\n}", ""]);

// exports
